import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground" data-testid="loading-screen">Loading…</div>;
  }
  if (!user) return <Navigate to={role === "super_admin" ? "/admin/login" : "/login"} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
